import { Component, OnInit } from '@angular/core'
import { PopoverController } from '@ionic/angular'
import { Pia3AuthenticationService } from '../../authentication/authentication.service'
import { Pia3CurrentUserFabPopoverComponent } from '../pia3-current-user-fab-popover/pia3-current-user-fab-popover.component'

@Component({
    selector: 'pia3-current-user-fab',
    templateUrl: './pia3-current-user-fab.component.html',
    styleUrls: ['./pia3-current-user-fab.component.scss'],
})
export class Pia3CurrentUserFabComponent implements OnInit {
    public currentUser: any = null

    constructor(private authService: Pia3AuthenticationService, public popoverController: PopoverController) {
        //Listen for currentLoggedInUser
        this.authService.currentLoggedInUser.subscribe((user) => {
            this.currentUser = user
        })
    }

    ngOnInit() {}

    async presentCurrentUserFabPopover(event: any) {
        const popover = await this.popoverController.create({
            component: Pia3CurrentUserFabPopoverComponent,
            componentProps: {
                senderEvent: event,
            },
            cssClass: 'currentUserFabPopoverComponent',
            event: event,
            translucent: true,
        })
        await popover.present()

        const { role } = await popover.onDidDismiss()
        ////////console.log('onDidDismiss resolved with role', role)
    }
}
